import React from 'react';
import { CircleDot, Circle } from 'lucide-react';

const getEventLabel = (type) => {
  switch (type) {
    case 'created': return 'Venta creada';
    case 'confirmed': return 'Venta confirmada';
    case 'paid': return 'Pago registrado';
    case 'delivered': return 'Entrega completada';
    default: return type;
  }
};

const TimelineEvent = ({ event, isFirst }) => (
  <div className="flex items-start gap-3">
    <div className="pt-1">
      {isFirst ? (
        <CircleDot className="w-5 h-5 text-blue-500 dark:text-blue-400" />
      ) : (
        <Circle className="w-5 h-5 text-gray-300 dark:text-gray-600" />
      )}
    </div>
    <div className="flex-1">
      <div className="font-medium text-gray-900 dark:text-white">
        {getEventLabel(event.type)}
      </div>
      <div className="text-sm text-gray-500 dark:text-gray-400">
        por {event.user.name}
      </div>
      <div className="text-sm text-gray-400 dark:text-gray-500">
        {new Date(event.timestamp).toLocaleString()}
      </div>
    </div>
  </div>
);

const Timeline = ({ history }) => (
  <div className="space-y-4">
    {history.map((event, index) => (
      <TimelineEvent 
        key={index} 
        event={event} 
        isFirst={index === 0}
      />
    ))}
  </div>
);

export default Timeline; 